import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFood = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "food",
	"data-name": "food",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 10.09,
			cy: 12,
			r: 4.77
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M11.51,1.5c2.86,0,6.69,0,8.78,3.05,3.51,5.11-2.85,7.85,0,9.81s2.68,5.57,1,6.86c-3.28,2.45-7.1-2.59-11.65.65C5.7,24.65-.19,17.78,2,10.23,3.06,6.35,6.73,1.5,11.51,1.5Z"
		})
	]
});
const ForwardRef = forwardRef(SvgFood);
export default ForwardRef;
